import { FaLocationDot, FaRegNewspaper } from "react-icons/fa6";
import { MdFitnessCenter } from "react-icons/md";
import { RiUserSearchLine } from "react-icons/ri";
import { FaIdCardClip } from "react-icons/fa6";
import { FaUnlockAlt } from "react-icons/fa";
import { FaUserLock } from "react-icons/fa";
import { getApiCEP } from "../commons/utils";
import EscalatorWarningIcon from '@mui/icons-material/EscalatorWarning';
import Groups2Icon from '@mui/icons-material/Groups2';
import { MdSupportAgent } from "react-icons/md";
import { TfiAgenda } from "react-icons/tfi";
import { BiMessageEdit } from "react-icons/bi";
import { BsJournal, BsQuestionOctagonFill, BsStopwatch } from "react-icons/bs";
import { LuAlertTriangle } from "react-icons/lu";
import { FaPersonRunning } from "react-icons/fa6";
import { GiJumpingRope } from "react-icons/gi";
import { TbCategory, TbHistoryToggle } from "react-icons/tb";
import { BsJournalCheck } from "react-icons/bs";
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import { TbMessage2Plus } from "react-icons/tb";
import { PiPlugsConnected } from "react-icons/pi";
import { BookCheck, FolderTree, HandCoins, NotebookPen, Wallet } from "lucide-react";

const options_sexo = [
    { value: 0, label: 'MASCULINO' },
    { value: 1, label: 'FEMININO' },
    { value: 3, label: 'TRANSGÊNERO' },
    { value: 4, label: 'NÃO BINÁRIO' },
    { value: 2, label: 'PREFIRO NÃO INFORMAR' },
    { value: 5, label: 'OUTRO' }
]

const options_tipo_aula = [
    { value: 1, label: 'DIÁRIO' },
    { value: 2, label: 'SEMANAL' }
]

const options_tipo_instancia = [
    { value: 1, label: 'USUÁRIO' },
    { value: 2, label: 'PAINEL' }
]

const options_tipo_template = [
    { value: 1, label: 'SOLICITAR ANAMNESE' },
    { value: 2, label: 'AGENDAMENTO AULA' },
    { value: 3, label: 'CONFIRMAÇÃO PRESENÇA' },
    { value: 4, label: 'PÓS EXPERIMENTAL' },
    { value: 5, label: 'PÓS FALTA' },
    { value: 6, label: 'AGUARDANDO RETORNO' },
    { value: 7, label: 'CONVERTIDO' },
    { value: 8, label: 'RESGATE' }
]

const options_tipo_conta = [
    { value: 0, label: 'INTERNA' },
    { value: 1, label: 'BANCÁRIA' }
]

const options_tipo_categoria_financeiro = [
    { value: 0, label: 'RECEITA' },
    { value: 1, label: 'DESPESA' }
]

const option_tipo_centro_resultado = [
    { value: 0, label: 'CUSTO' },
    { value: 1, label: 'RECEITA' }
]

export function getTipoTemplate(_value: any) {
    const option = options_tipo_template.find(opt => opt.value === _value);
    return option ? option.label : '';
}

export function getSexo(_value: any) {
    const sexo = options_sexo.find(option => option.value === _value);
    return sexo ? sexo.label : 'Opção não encontrada';
}

export const model_local = {
    icon: <FaLocationDot />,
    name: 'Local',
    key: 'localid',
    inactive_field: 'localativo',
    description_field: 'localdescricao',
    api_get: '/locais',
    api_post: '/local',
    api_delete: '/local',
    inputs: [
        { id: 'localid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'localdescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 100 }
    ],
    base: {
        localid: 0,
        localdescricao: '',
        localativo: 1
    }
}

export const model_modalidade = {
    icon: <MdFitnessCenter />,
    name: 'Modalidade',
    key: 'modalidid',
    inactive_field: 'modalidativo',
    description_field: 'modaliddescricao',
    api_get: '/modalidades',
    api_post: '/modalidade',
    api_delete: '/modalidade',
    inputs: [
        { id: 'modalidid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'modaliddescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 100 }
    ],
    base: {
        modalidid: 0,
        modaliddescricao: '',
        modalidativo: 1
    }
}

export const model_tipo_prospeccao = {
    icon: <RiUserSearchLine />,
    name: 'Tipo Prospecção',
    key: 'tipprospecid',
    inactive_field: 'tipprospecativo',
    description_field: 'tipprospecdescricao',
    api_get: '/tiposProspeccao',
    api_post: '/tipoProspeccao',
    api_delete: '/tipoProspeccao',
    inputs: [
        { id: 'tipprospecid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'tipprospecdescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 100 },
        { id: 'tipprospecindicaluno', label: 'Indicação Aluno', type: 'check', md: 6 },
        { id: 'tipprospecindicterceiro', label: 'Indicação Terceiro', type: 'check', md: 6 },
    ],
    base: {
        tipprospecid: 0,
        tipprospecdescricao: '',
        tipprospecindicaluno: 0,
        tipprospecindicterceiro: 0,
        tipprospecativo: 1
    }
}

export const model_cores = {
    key: 'corid',
    description_field: 'cordescricao',
    api_get: '/turma/cores'
}

export const model_turma = {
    icon: <Groups2Icon />,
    name: 'Turma',
    key: 'turmaid',
    inactive_field: 'turmaativo',
    description_field: 'turmadescricao',
    api_get: '/turmas',
    api_post: '/turma',
    api_delete: '/turma',
    inputs: [
        { id: 'turmaid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'turmadescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 100 },
        { id: 'local.localid', label: 'Local', type: 'select', md: 12, required: true, model: model_local },
        { id: 'modalidade.modalidid', label: 'Modalidade', type: 'select', md: 12, required: true, model: model_modalidade },
        { id: 'turmatempo', label: 'Tempo (Minutos)', type: 'number', md: 4, required: true },
        { id: 'turmavagas', label: 'Vagas', type: 'number', md: 4, required: true },
        { id: 'turmacor', label: 'Cor', type: 'select', md: 4, required: true, model: model_cores },
    ],
    base: {
        turmaid: 0,
        turmadescricao: '',
        turmavagas: 0,
        turmatempo: 0,
        turmacor: 0,
        turmaativo: 1,
        local: { localid: 0 },
        modalidade: { modalidid: 0 }
    }
}

export const model_privilegio = {
    icon: <FaUnlockAlt />,
    name: 'Privilégio',
    key: 'privid',
    description_field: 'privdescricao',
    api_get: '/privilegios',
    api_post: '/privilegio',
    api_delete: '/privilegio',
    inputs: [
        { id: 'privid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'privdescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 30 }
    ],
    base: {
        privid: 0,
        privdescricao: ''
    }
}

export const model_usuario = {
    icon: <FaIdCardClip />,
    name: 'Usuário',
    key: 'usuid',
    description_field: 'usunome',
    api_get: '/usuarios',
    api_post: '/usuario',
    api_delete: '/usuario',
    inputs: [
        { id: 'usuid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'usunome', label: 'Nome', type: 'text', md: 9, required: true, maxLength: 50 },
        { id: 'usuemail', label: 'E-mail', type: 'text', md: 12, required: true, maxLength: 40 },
        { id: 'ususenha', label: 'Senha', type: 'password', md: 12, required: true, maxLength: 100 }
    ],
    base: {
        usuid: 0,
        usunome: '',
        usuemail: '',
        ususenha: ''
    }
}

export const model_instancia = {
    icon: <PiPlugsConnected />,
    name: 'Instância',
    key: 'instid',
    api_get: '/instancias',
    api_post: '/instancia',
    description_field: 'instdescricao',
    inputs: [
        { id: 'instdescricao', label: 'Descrição', type: 'text', md: 12, maxLength: 50 },
        { id: 'insttipo', label: 'Tipo', type: 'select', required: true, options: options_tipo_instancia, md: 6 }
    ],
    base: {
        instid: ''
    }
}

export const model_usuario_empresa = {
    icon: <FaUserLock />,
    name: 'Usuário Empresa',
    key: 'usuid',
    inactive_field: 'usuempativo',
    description_field: 'usuario.usunome',
    api_get: '/usuariosEmpresa',
    api_post: '/usuarioEmpresa',
    inputs: [
        { id: 'usuario.usuid', label: 'Usuário', type: 'select', md: 12, model: model_usuario },
        { id: 'privilegio.privid', label: 'Privilégio', type: 'select', md: 12, required: true, model: model_privilegio },
        { id: 'instancia.instid', label: 'Instância', type: 'select', md: 12, model: model_instancia },
    ],
    base: {
        usuario: {
            usuid: 0
        },
        privilegio: {
            privid: 0
        },
        instancia: {
            instid: 0
        },
        usuempativo: 1
    }
}

function changeCEP(_newValue: any, refs: any) {
    if (_newValue.length === 9) {
        getApiCEP(_newValue.replace('-', ''))
            .then((data: any) => {
                refs.current['prosplogradouro'].setValue(data.logradouro);
                refs.current['prospbairro'].setValue(data.bairro);
                refs.current['prospcidade'].setValue(data.localidade);
                refs.current['prospcomplemento'].setValue(data.complemento);
                refs.current['propsuf'].setValue(data.uf);
            })
            .catch((error: any) => {
                console.log(error)
            })
    }
}

export const model_prospect = {
    icon: <EscalatorWarningIcon />,
    name: 'Prospect',
    key: 'prospid',
    api_get: '/prospects',
    api_post: '/prospect',
    api_delete: '/prospect',
    hasEmpresa: true,
    description_field: 'prospnome',
    inputs: [
        { id: 'prospid', label: 'Código', type: 'number', disabled: true, md: 2, tab: 'Dados' },
        { id: 'prospnome', label: 'Nome', type: 'text', md: 10, required: true, maxLength: 50, tab: 'Dados' },
        { id: 'prospcpf', label: 'CPF', type: 'text', md: 4, required: true, model: 'cpf', tab: 'Dados' },
        { id: 'prosptelefone', label: 'Telefone', type: 'text', md: 4, required: true, model: 'phone', tab: 'Dados' },
        { id: 'prosptelemergencia', label: 'Tel. Emergência', type: 'text', md: 4, required: true, model: 'phone', tab: 'Dados' },
        { id: 'prospemail', label: 'E-mail', type: 'text', md: 6, required: true, model: 'email', maxLength: 50, tab: 'Dados' },
        { id: 'prospnascimento', label: 'Nascimento', type: 'date', md: 3, required: true, tab: 'Dados' },
        { id: 'prospsexo', label: 'Sexo', type: 'select', md: 3, required: true, options: options_sexo, tab: 'Dados' },
        { id: 'tipoProspeccao.tipprospecid', label: 'Tipo Prospecção', type: 'select', md: 5, required: true, model: model_tipo_prospeccao, tab: 'Dados' },
        { id: 'usuario.usuid', label: 'Consultor', type: 'select', md: 4, required: true, model: model_usuario, tab: 'Dados' },
        { id: 'prospcep', label: 'CEP', type: 'text', md: 3, required: true, model: 'cep', onAfterChange: changeCEP, tab: 'Dados' },
        { id: 'prosplogradouro', label: 'Endereço', type: 'text', md: 10, required: true, maxLength: 50, tab: 'Dados' },
        { id: 'prospnumero', label: 'Número', type: 'text', md: 2, required: true, maxLength: 10, tab: 'Dados' },
        { id: 'prospbairro', label: 'Bairro', type: 'text', md: 4, required: true, maxLength: 30, tab: 'Dados' },
        { id: 'prospcidade', label: 'Cidade', type: 'text', md: 3, required: true, maxLength: 30, tab: 'Dados' },
        { id: 'prospuf', label: 'UF', type: 'text', md: 2, required: true, maxLength: 2, tab: 'Dados' },
        { id: 'prospcomplemento', label: 'Complemento', type: 'text', md: 3, maxLength: 50, tab: 'Dados' },
        { id: 'prospfoto', type: 'photo', md: 12, tab: 'Foto' },
    ],
    inputs_pub: [
        { id: 'prospnome', label: 'Nome', type: 'text', md: 12, required: true, maxLength: 50 },
        { id: 'prospcpf', label: 'CPF', type: 'text', md: 4, required: true, model: 'cpf' },
        { id: 'prosptelefone', label: 'Telefone', type: 'text', md: 4, required: true, model: 'phone' },
        { id: 'prosptelemergencia', label: 'Tel. Emergência', type: 'text', md: 4, required: true, model: 'phone' },
        { id: 'prospemail', label: 'E-mail', type: 'text', md: 8, required: true, model: 'email', maxLength: 50 },
        { id: 'prospnascimento', label: 'Nascimento', type: 'date', md: 4, required: true },
        { id: 'prospsexo', label: 'Sexo', type: 'select', md: 6, required: true, options: options_sexo },
        { id: 'tipoProspeccao.tipprospecid', label: 'Tipo Prospecção', type: 'select', md: 6, required: true, model: model_tipo_prospeccao },
        { id: 'prospcep', label: 'CEP', type: 'text', md: 3, required: true, model: 'cep', onAfterChange: changeCEP },
        { id: 'prosplogradouro', label: 'Endereço', type: 'text', md: 9, required: true, maxLength: 50 },
        { id: 'prospnumero', label: 'Número', type: 'text', md: 3, required: true, maxLength: 10 },
        { id: 'prospbairro', label: 'Bairro', type: 'text', md: 9, required: true, maxLength: 30 },
        { id: 'prospcidade', label: 'Cidade', type: 'text', md: 9, required: true, maxLength: 30 },
        { id: 'prospuf', label: 'UF', type: 'text', md: 3, required: true, maxLength: 2 },
        { id: 'prospcomplemento', label: 'Complemento', type: 'text', md: 12, maxLength: 50 },
    ],
    base: {
        prospid: 0,
        prospnome: '',
        prospcpf: '',
        prosptelefone: '',
        prospemail: '',
        prospnascimento: '',
        prospsexo: 0,
        prospcep: '',
        prosplogradouro: '',
        prospnumero: '',
        prospbairro: '',
        prospcidade: '',
        prospcomplemento: '',
        prosptelemergencia: '',
        tipoProspeccao: {
            tipprospecid: 0
        },
        usuario: {
            usuid: 0
        },
        tipprospecdetalhe: '',
        empresa: {
            empid: 0
        }
    },
    size: 'lg'
}

export const model_prospect_observacoes = {
    name: 'Prospect Observações',
    key: 'contprospitemid',
    subKey: ['contprospid', 'prospid'],
    api_get: '/controleProspeccaoItens',
    api_post: '/controleProspeccaoItem',
    api_delete: '/controleProspeccaoItem',
    hasEmpresa: true,
    inputs: [{
        id: 'contprospitemobs', label: 'Observação', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 500
    }],
    base: {
        empid: 0,
        contprospitemid: 0,
        contprospid: 0,
        prospid: 0
    }
}

/*const model_prospect_hasempresa = {
    ...model_prospect,
    api_get: '/prospects?hasEmpresa=1',
}*/

export const model_aula = {
    icon: <TfiAgenda />,
    name: 'Aula',
    key: 'aulaid',
    api_get: '/aulas',
    api_post: '/aula',
    api_delete: '/aula',
    inactive_field: 'aulaativo',
    description_field: 'aulainicio',
    inputs: [
        { id: 'aulaid', label: 'Código', type: 'text', md: 2, disabled: true },
        { id: 'turma.turmaid', label: 'Turma', type: 'select', md: 7, required: true, model: model_turma },
        { id: 'aulavagas', label: 'Vagas', type: 'number', md: 3, required: true },
        { id: 'aulatipo', label: 'Tipo', type: 'select', md: 4, required: true, options: options_tipo_aula },
        { id: 'auladatainicio', label: 'Data Início', type: 'date', md: 4, required: true },
        { id: 'aulainicio', label: 'Início', type: 'time', md: 4, required: true },
        { id: 'auladias', label: 'Dias', type: 'week', md: 12 },
    ],
    base: {
        aulaid: 0,
        turma: {
            turmaid: 0
        },
        aulaativo: 1
    }
}

export const model_aula_dia = {
    ...model_aula,
    api_get: '/aulasDisponivelDia',
    description_field: 'auladescricao',
    params_required: true,
}

export const model_log = {
    icon: <FaRegNewspaper />,
    name: 'Logs',
    key: 'logid',
    description_field: 'loglog',
    api_get: '/plataforma/logs'
}

function changeTipoProspeccao(_newValue: any, refs: any) {
    if (_newValue.tipprospecindicaluno === 1)
        refs.current['prospect.prospid'].setDisabled(false)
    else {
        refs.current['prospect.prospid'].setValue(undefined);
        refs.current['prospect.prospid'].setDisabled(true)
    }

    if (_newValue.tipprospecindicterceiro === 1)
        refs.current['leadindicacao'].setDisabled(false)
    else {
        refs.current['leadindicacao'].setValue('');
        refs.current['leadindicacao'].setDisabled(true)
    }
}


export const model_lead = {
    icon: <MdSupportAgent />,
    name: 'Lead',
    key: 'leadid',
    description_fields: 'leadnome',
    api_get: '/leads',
    api_post: '/lead',
    api_delete: '/lead',
    hasEmpresa: true,
    inputs: [
        { id: 'leadnome', label: 'Nome', type: 'text', md: 12, required: true, maxLength: 100 },
        { id: 'leadcontato', label: 'Telefone', type: 'text', md: 6, model: 'phone' },
        { id: 'leadretorno', label: 'Retorno', type: 'datetime-local', md: 6 },
        { id: 'leadnascimento', label: 'Nascimento', type: 'date', md: 4, required: true },
        { id: 'tipoProspeccao.tipprospecid', label: 'Tipo Prospecção', type: 'select', md: 8, required: true, model: model_tipo_prospeccao, onAfterChange: changeTipoProspeccao },
        { id: 'prospect.prospid', label: 'Aluno Indicador', type: 'select', md: 12, model: model_prospect },
        { id: 'leadindicacao', label: 'Terceiro Indicador', type: 'text', md: 12, maxLength: 100 },
        { id: 'leadobs', label: 'Observação', type: 'text', md: 12, textarea: true, rows: 3, maxLength: 500 }
    ],
    base: {
        empid: 0,
        leadid: 0,
        leadnome: '',
        leadcontato: '',
        leadretorno: '',
        leadnascimento: '',
        tipoProspeccao: {
            tipprospecid: 0
        },
        leadobs: '',
        leadsituacao: 1
    }
}

function setFilterAula(turma: any, dia: any, refs: any) {
    if (turma !== '')
        refs.current['aula.aulaid'].setFilter('?turmaid=' + turma + '&auladatainicio=' + dia)
}

function changeDia(_newValue: any, refs: any) {
    if ((_newValue) && (refs.current['turmaid'].getValue()))
        setFilterAula(refs.current['turmaid'].getValue(), _newValue, refs)
    else
        setFilterAula('', '', refs)
}

function changeTurma(_newValue: any, refs: any) {
    if ((_newValue.value > 0) && (refs.current['agendadia'].getValue()))
        setFilterAula(_newValue.value, refs.current['agendadia'].getValue(), refs)
    else
        setFilterAula('', '', refs)
}

export const model_agenda = {
    icon: <GiJumpingRope />,
    name: 'Agenda',
    key: 'agendaid',
    api_get: '/agendas',
    api_post: '/agenda',
    inputs: [
        { id: 'prospect.prospid', label: 'Prospect', type: 'select', md: 12, required: true, model: model_prospect },
        { id: 'agendadia', label: 'Data', type: 'date', md: 4, required: true, onAfterChange: changeDia },
        { id: 'turmaid', label: 'Turma', type: 'select', md: 8, required: true, model: model_turma, onAfterChange: changeTurma },
        { id: 'aula.aulaid', label: 'Aula', type: 'select', md: 12, required: true, model: model_aula_dia }
    ],
    base: {
        agendaid: 0,
        prospect: {
            prospid: 0
        },
        agendadia: '',
        aula: {
            aulaid: 0
        },
        agendapresente: 0
    }
}

export const model_motivo = {
    icon: <BsQuestionOctagonFill />,
    name: 'Motivo',
    key: 'motid',
    inactive_field: 'motativo',
    description_field: 'motdescricao',
    api_get: '/motivos',
    api_post: '/motivo',
    api_delete: '/motivo',
    inputs: [
        { id: 'motid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'motdescricao', label: 'Descrição', type: 'text', md: 9, required: true, maxLength: 200 },
    ],
    base: {
        motid: 0,
        motdescricao: '',
        mottipo: 0,
        motativo: 1
    }
}

export const model_feedback = {
    icon: <BiMessageEdit />,
    name: 'Feedback',
    key: 'sacid',
    api_get: 'feedbacks',
    inputs: [],
}

export const model_docao = {
    icon: <FaRegNewspaper />,
    name: 'Doações',
    key: 'doacaoid',
    description_field: 'doacaonome',
    api_get: '/doacoes'
}

export const model_prospect_naoconvertido = {
    name: 'Prospect Não Convertido',
    api_post: '/prospect/naoConvertido',
    inputs: [
        { id: 'motid', label: 'Motivo', type: 'select', md: 12, model: model_motivo, required: true },
        { id: 'contprospobservacao', label: 'Observação', type: 'text', md: 12, textarea: true, rows: 3, maxLength: 200 }
    ],
    base: {}
}

export const model_lead_detalhe = {
    icon: <NotebookPen />,
    name: 'Lead Observações',
    key: 'leaditemid',
    subKey: ['leadid'],
    api_get: '/lead/detalhes',
    api_post: '/leadItem',
    api_delete: '/leadItem',
    hasEmpresa: true,
    inputs: [{
        id: 'leaditemcomentario', label: 'Observação', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 500
    }],
    base: {}
}

export const model_lead_enrolado = {
    name: 'Lead Enrolado',
    api_post: '/lead/pausado',
    inputs: [{ id: 'leadmotivo', label: 'Motivo', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 200 }],
    base: {}
}

export const model_lead_curioso = {
    name: 'Lead Curioso',
    api_post: '/lead/curioso',
    inputs: [{ id: 'leadmotivo', label: 'Motivo', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 200 }],
    base: {}
}

export const model_usuario_presenca = {
    name: 'Usuário Presença',
    api_post: '/agenda/alteraPresenca',
    inputs: [{ id: 'usuid', label: 'Professor', type: 'select', md: 12, required: true, model: model_usuario, isMulti: true }],
    base: {}
}

export const model_controle_prospeccao = {
    name: 'Controle Prospecção',
    api_get: '/controlesProspeccao'
}

export const model_empresa = {
    name: 'Empresa',
    key: 'empid',
    api_get: '/empresas',
    description_field: 'empnome',
}

export const model_report_faltas = {
    icon: <LuAlertTriangle />,
    name: 'Relatório de Faltas',
    api_get: '/agendas/faltas'
}

export const model_metodo = {
    icon: <BsJournal />,
    name: 'Método',
    key: 'metodoid',
    description_field: 'metodotitulo',
    inactive_field: 'metodoativo',
    api_get: '/metodos',
    api_post: '/metodo',
    api_delete: '/metodo',
    inputs: [
        { id: 'metodoid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'metodotitulo', label: 'Título', type: 'text', md: 9, required: true, maxLength: 100 },
        { id: 'metododescricao', label: 'Descrição', type: 'text', md: 12, textarea: true, rows: 2, maxLength: 100 },
        { id: 'metodocor', label: 'Cor', type: 'color', md: 12, required: true, maxLength: 20 },
    ],
    base: {
        metodoid: 0,
        metodotitulo: '',
        metododescricao: '',
        metodocor: '',
        metodoativo: 1
    }
}

export const model_exercicio = {
    icon: <FaPersonRunning />,
    name: 'Exercício',
    key: 'exercid',
    description_field: 'exercdescricao',
    inactive_field: 'exercativo',
    api_get: '/exercicios',
    api_post: '/exercicio',
    api_delete: '/exercicio',
    inputs: [
        { id: 'exercid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'exercdescricao', label: 'Descrição', type: 'text', md: 9, maxLength: 100 },
        { id: 'exercinformapeso', label: 'Informa Peso', type: 'check', md: 12 },
        { id: 'exercinformarepeticao', label: 'Informa Repetição', type: 'check', md: 12 },
        { id: 'exercinformaflexibilidade', label: 'Informa Flexibilidade', type: 'check', md: 12 },
    ],
    base: {
        exercid: 0,
        exercdescricao: '',
        exercativo: 1
    }
}

export const model_especificacao = {
    icon: <FaPersonRunning />,
    name: 'Especificação',
    key: 'especid',
    description_field: 'especdescricao',
    inactive_field: 'especativo',
    api_get: '/especificacoes',
    api_post: '/especificacao',
    api_delete: '/especificacao',
    inputs: [
        { id: 'especid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'especdescricao', label: 'Descrição', type: 'text', md: 9, maxLength: 100 },
        { id: 'exercicio.exercid', label: 'Exercício', type: 'select', md: 12, required: true, model: model_exercicio }
    ],
    base: {
        especid: 0,
        especdescricao: '',
        exercicio: {
            exercid: 0
        },
        especativo: 1
    }
}

export const model_historico_agendamento = {
    icon: <TbHistoryToggle />,
    name: 'Histórico Agendamento',
    api_get: '/prospect/agendas',
}

export const model_repeticao_tempo = {
    icon: <BsStopwatch />,
    name: 'Repetição/Tempo',
    key: 'etapaid',
    description_field: 'etapadescricao',
    inactive_field: 'etapaativo',
    api_get: '/etapas',
    api_post: '/etapa',
    api_delete: '/etapa',
    inputs: [
        { id: 'etapaid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'etapadescricao', label: 'Título', type: 'text', md: 9, required: true, maxLength: 500 }
    ],
    base: {
        etapaid: 0,
        etapadescricao: '',
        etapaativo: 1
    }
}

export const model_plano_aula = {
    icon: <BsJournalCheck />,
    name: 'Plano Aula',
    key: 'planoaulaid',
    description_field: 'planoauladescricao',
    inactive_field: 'planoaulaativo',
    api_get: '/planosAula',
    api_post: '/planoAula',
    api_delete: '/planoAula',
    inputs: [
        { id: 'planoaulaid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'planoauladescricao', label: 'Descrição', type: 'text', md: 9, maxLength: 100, required: true },
        { id: 'planoauladata', label: 'Data', type: 'date', md: 12, required: true },
        { id: 'metodo.metodoid', label: 'Método', type: 'select', md: 12, required: true, model: model_metodo }
    ],
    base: {
        planoaulaid: 0,
        planoauladescricao: '',
        planoauladata: '',
        metodo: {
            metodoid: 0
        },
        planoaulaativo: 1
    }
}

export const model_repeticao_tempo_exercicio = {
    name: 'Exercícios x Repetição/Tempo',
    key: 'etapaexercicioid',
    api_get: '/etapa/exercicios',
    api_post: '/etapa/exercicio',
    api_delete: '/etapa/exercicio',
    inputs: [
        { id: 'etapaexercicioid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'etapa.etapaid', label: 'Repetição/Tempo', type: 'select', required: true, disabled: true, model: model_repeticao_tempo, md: 9 },
        { id: 'exercicio.exercid', label: 'Exercício', type: 'select', required: true, model: model_exercicio, md: 12 },
        { id: 'etapaexercordem', label: 'Ordem', type: 'number', required: true, md: 3 },
    ],
    base: {
        etapaexercicioid: 0,
        etapa: {
            etapaid: 0
        },
        exercicio: {
            exercid: 0
        },
        etapaexercordem: 0
    }
}

export const model_planoaula_etapa = {
    icon: <FormatListNumberedIcon />,
    name: 'Repetição/Tempo x Plano de Aula',
    key: 'planoaulaetapaid',
    api_get: '/planoAula/etapa',
    api_post: '/planoAula/etapa',
    api_delete: '/planoAula/etapa',
    inputs: [
        { id: 'planoaulaetapaid', label: 'Código', type: 'number', disabled: true, md: 3 },
        { id: 'planoaula.planoaulaid', label: 'Plano Aula', type: 'select', disabled: true, model: model_plano_aula, md: 9 },
        { id: 'etapa.etapaid', label: 'Repetição/Tempo', type: 'select', required: true, model: model_repeticao_tempo, md: 12 },
        { id: 'planoaulaetapaordem', label: 'Ordem', type: 'number', required: true, md: 3 },
    ],
    base: {
        planoaulaetapaid: 0,
        planoaula: {
            planoaulaid: 0
        },
        etapa: {
            etapaid: 0
        },
        planoaulaetapaordem: 0
    }
}

export const model_plano_aula_modalidade = {
    icon: <BsJournalCheck />,
    name: 'Plano Aula Modalidade',
    key: 'planoaulamodid',
    api_get: '/planosAulaModalidade',
    api_post: '/planoAulaModalidade',
    api_delete: '/planoAulaModalidade',
    inputs: [
        { id: 'planoAula.planoaulaid', label: 'Plano Aula', type: 'select', md: 12, required: true, model: model_plano_aula },
        { id: 'modalidade.modalidid', label: 'Modalidade', type: 'select', md: 12, required: true, model: model_modalidade },
        { id: 'planoaulamodfrase', label: 'Frase do Dia', type: 'text', md: 12, textarea: true, rows: 3, maxLength: 500 },
    ],
    base: {
        planoaulamodid: 0,
        planoAula: {
            planoaulaid: 0
        },
        modalidade: {
            modalidid: 0
        },
        planoaulamodfrase: ''
    }
}

export const model_template_mensagem = {
    icon: <TbMessage2Plus />,
    name: 'Template Mensagem',
    key: 'templid',
    api_get: '/templates',
    api_post: '/template',
    api_delete: '/template',
    inputs: [
        { id: 'templdescricao', label: 'Descrição', type: 'text', md: 12, maxLength: 50 },
        { id: 'templtipo', label: 'Tipo', type: 'select', required: true, options: options_tipo_template, md: 12 },
        { id: 'templconteudo', label: 'Template', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 5000 },
    ],
    base: {
        templid: ''
    },
    size: 'lg'
}


export const model_categoria = {
    icon: <TbCategory />,
    name: 'Categoria',
    key: 'catid',
    description_field: 'catdescricao',
    inactive_field: 'catativo',
    api_get: '/categorias',
    api_post: '/categoria',
    api_delete: '/categoria',
    inputs: [
        { id: 'catdescricao', label: 'Descrição', type: 'text', md: 12, maxLength: 100 }
    ],
    base: {
        catid: '',
        catativo: 1
    }
}

export const model_categoria_exercicio = {
    icon: <TbCategory />,
    name: 'Categoria x Exercício',
    key: 'catexercid',
    api_get: '/categoria/exercicios',
    api_post: '/categoria/exercicio',
    api_delete: '/categoria/exercicio',
    inputs: [
        { id: 'categoria.catid', label: 'Categoria', type: 'select', disabled: true, model: model_categoria, md: 12 },
        { id: 'exercicio.exercid', label: 'Exercício', type: 'select', required: true, model: model_exercicio, md: 12 }
    ],
    base: {
        catexercid: '',
        categoria: {
            catid: ''
        },
        exercicio: {
            exercid: 0
        }
    }
}

export const model_exercicio_categoria = {
    ...model_categoria_exercicio,
    api_get: '/exercicio/categorias',
    inputs: [
        { id: 'exercicio.exercid', label: 'Exercício', type: 'select', disabled: true, model: model_exercicio, md: 12 },
        { id: 'categoria.catid', label: 'Categoria', type: 'select', required: true, model: model_categoria, md: 12 }
    ]
}

export const model_banco = {
    name: 'Banco',
    key: 'bancoid',
    inactive_field: 'bancoativo',
    description_field: 'bancodescricao',
    api_get: '/bancos',
}

function changeTipoConta(_newValue: any, refs: any) {
    const bancaria = _newValue.value === 1;

    refs.current['banco.bancoid'].setDisabled(!bancaria);
    refs.current['connumero'].setDisabled(!bancaria);
    refs.current['conagencia'].setDisabled(!bancaria);
    refs.current['condigito'].setDisabled(!bancaria);

    if (!bancaria) {
        refs.current['banco.bancoid'].setValue(undefined);
        refs.current['connumero'].setValue('');
        refs.current['conagencia'].setValue('');
        refs.current['condigito'].setValue('');
    }
}

export const model_conta = {
    icon: <Wallet />,
    name: 'Conta',
    key: 'conid',
    inactive_field: 'conativo',
    description_field: 'condescricao',
    api_get: '/contas',
    api_post: '/conta',
    api_delete: '/conta',
    inputs: [
        { id: 'condescricao', label: 'Descrição', type: 'text', maxLength: 100, md: 8, required: true },
        { id: 'contipo', label: 'Tipo', type: 'select', options: options_tipo_conta, md: 4, required: true, onAfterChange: changeTipoConta, disableEdit: true },
        { id: 'banco.bancoid', label: 'Banco', type: 'select', model: model_banco, md: 12, },
        { id: 'connumero', label: 'Número', type: 'text', maxLength: 10, md: 5, },
        { id: 'conagencia', label: 'Agência', type: 'text', maxLength: 6, md: 4, },
        { id: 'condigito', label: 'Dígito', type: 'text', maxLength: 1, md: 2 }
    ],
    base: {
        conid: '',
        connumero: '',
        conagencia: '',
        condigito: '',
        banco: {
            bancoid: ''
        },
        conativo: 1
    }
}

export const model_categoria_financeiro_consulta = {
    name: 'Categoria',
    key: 'catfinid',
    inactive_field: 'catfinativo',
    description_field: 'catfindescricao',
    api_get: '/categoriasFinanceiro',
}

export const model_categoria_financeiro = {
    icon: <FolderTree />,
    name: 'Categoria (Financeiro)',
    key: 'catfinid',
    inactive_field: 'catfinativo',
    description_field: 'catfindescricao',
    api_get: '/categoriasFinanceiro',
    api_post: '/categoriaFinanceiro',
    inputs: [
        { id: 'catfintipo', label: 'Tipo', type: 'select', options: options_tipo_categoria_financeiro, md: 4, required: true, disableEdit: true },
        { id: 'catfindescricao', label: 'Descrição', type: 'text', maxLength: 100, md: 12, required: true },
        { id: 'categoriapai.catfinid', label: 'Categoria', type: 'select', model: model_categoria_financeiro_consulta, md: 12, disableEdit: true }
    ],
    base: {
        catfinid: '',
        categoriapai: {
            catfinid: ''
        },
        catfinativo: 1
    }
}

export const model_forma_pagamento = {
    icon: <HandCoins />,
    name: 'Forma de Pagamento',
    key: 'forpagid',
    inactive_field: 'forpagativo',
    description_field: 'forpagdescricao',
    api_get: '/formasPagamento',
    api_post: '/formaPagamento',
    api_delete: '/formaPagamento',
    inputs: [
        { id: 'forpagdescricao', label: 'Descrição', type: 'text', maxLength: 100, md: 12, required: true },
        { id: 'conta.conid', label: 'Conta Padrão', type: 'select', model: model_conta, md: 12 }
    ],
    base: {
        forpagid: '',
        conta: {
            conid: ''
        },
        forpagativo: 1
    }
}

export const model_centro_resultado = {
    icon: <BookCheck />,
    name: 'Centro de Resultado',
    key: 'centresid',
    inactive_field: 'centrestativo',
    description_field: 'centresdescricao',
    api_get: '/centrosResultado',
    api_post: '/centroResultado',
    api_delete: '/centroResultado',
    inputs: [
        { id: 'centrestipo', label: 'Tipo', type: 'select', options: option_tipo_centro_resultado, md: 4, required: true, disableEdit: true },
        { id: 'centresdescricao', label: 'Descrição', type: 'text', maxLength: 100, md: 12, required: true },
    ],
    base: {
        centresid: '',
        centrestativo: 1
    }
}

export const model_cliente_observacao = {
    icon: <NotebookPen />,
    name: 'Observação Cliente',
    key: 'prospobsid',
    api_get: '/prospect/detalhes',
    api_post: '/prospectObservacao',
    api_delete: '/prospectObservacao',
    hasEmpresa: true,
    inputs: [
        { id: 'prospobscomentario', label: 'Comentário', type: 'text', md: 12, required: true, textarea: true, rows: 3, maxLength: 500 }
    ],
    base: {}
}